// Resources:
// https://www.youtube.com/watch?v=BuJ3yrpSj-g

// import 'phaser';
import bindAllOfThis from "src/utils/BindThisHelper";
import { PhaserButton, PhaserButtonConfig } from 'src/games/shared/Button';
import TranslateApi from 'src/utils/TranslateHelper';
import { Color } from 'src/games/shared/ColorValue';
import { EndGameScene } from 'src/games/XraySlider/scenes/EndGameScene';

export class MainScene extends Phaser.Scene {
    private BOARD_DIM: number = 3;
    private GAME_WIDTH: number = 1360;
    private GAME_HEIGHT: number = 768;

    private PIECE_WIDTH: number;
    private PIECE_HEIGHT: number;

    private blockGroup: Phaser.GameObjects.Image[];
    private blackBlock: Phaser.GameObjects.Image;
    private blocksLeftText: Phaser.GameObjects.Text;
    private clickLock: boolean;

    private borderSize: number;
    private count: number;
    private text: Phaser.GameObjects.Text;
    private outline: Phaser.GameObjects.Image;
    private speechBox: Phaser.GameObjects.Image;

    private translateString: string;

    private timer: Phaser.Time.TimerEvent;
    private timeText: Phaser.GameObjects.Text;
    private startTime: boolean;

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
        this.startTime = false;
        if (this.BOARD_DIM === 3) {
            this.borderSize = 5;
            this.PIECE_WIDTH = Math.floor(this.GAME_WIDTH / 6);
            this.PIECE_HEIGHT = this.PIECE_WIDTH;
        }
        else {
            try {
                throw new Error("Not a valid board dimension, must be 3");
            }
            catch (e) {
                console.warn(e);
            }
        }
    }

    preload() {
        this.load.spritesheet("key", require("/src/assets/qci/sprites/xRay/xray__complete.png"), { frameWidth: this.PIECE_WIDTH, frameHeight: this.PIECE_HEIGHT });
        this.load.image("finishedKey", require("/src/assets/qci/sprites/xRay/xray__complete.png"));
        this.load.image("template", require("/src/assets/qci/sprites/xRay/xray__key.png"));
        this.load.image("white", require("/src/assets/games/coinRunner/white.png"));
        this.load.atlas("pilots", require("/src/assets/qci/atlas/starPilotAll.png"), require("/src/assets/qci/atlas/starPilotAll.json"));
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.image("bg", require("/src/assets/qci/sprites/xRay/grade3-I__bg.png"));
        this.load.image("bg_done", require("/src/assets/qci/sprites/xRay/grade3-I__bg-completed.png"));
    }

    create() {
        this.translateString = "XRay.Phaser.";
        this.add.image(0, 0, "bg").setOrigin(0).setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT).setDepth(0);
        this.timeText = this.add.text(this.GAME_WIDTH - 125, 200, "0:00", { fill: "#000000", align: "center" }).setDepth(7.5).setOrigin().setFontFamily('Russo One, Roboto Mono, Arial').setFontSize(30);
        this.setupTimer();
        this.setupBoard();
        this.checkNumLeft();
        this.addControlPanel();
        this.addRescrambleButton();
        this.makeBlocksLeftBox();
    }

    setupBoard(): void {
        this.clickLock = false;
        let order: number[] = [];
        order = this.createSolvableIndexArray();
        this.createBlocks(order);
    }

    createBlocks(orderArray: number[]): void {
        this.blockGroup = [];
        let count = 0;
        var padding = 4 * this.borderSize;

        for (let row = 0; row < this.BOARD_DIM; row++) {
            for (let col = 0; col < this.BOARD_DIM; col++) {
                // Wherever the largest number is in the order array, use that index for the black block
                if (orderArray[count] === this.BOARD_DIM * this.BOARD_DIM - 1) {
                    this.blackBlock = this.add.sprite((col) * (this.PIECE_WIDTH + 2) + padding, (row) * (this.PIECE_HEIGHT + 2) + 2 * padding, "white");
                    this.blackBlock.setOrigin(0);
                    this.blackBlock.setDepth(1);
                    this.blackBlock.setAlpha(0);
                    this.blackBlock.setDisplaySize(this.PIECE_WIDTH, this.PIECE_HEIGHT);
                    this.blackBlock.name = "black";
                    this.blackBlock.setData("key", orderArray[count]);
                    this.blockGroup.push(this.blackBlock);
                    count++;
                }
                // Create normal blocks using the sprite for the rest of the blocks
                else {
                    let block: Phaser.GameObjects.Image = this.add.sprite((col) * (this.PIECE_WIDTH + 2) + padding, (row) * (this.PIECE_HEIGHT + 2) + 2 * padding, "key", orderArray[count]);
                    block.setOrigin(0);
                    block.setInteractive();
                    block.setDepth(2);
                    block.setDisplaySize(this.PIECE_WIDTH, this.PIECE_HEIGHT);
                    block.setData("key", orderArray[count]);
                    block.on('pointerdown', () => {
                        this.switchBlocks(block, this.blackBlock);
                    });
                    count++;
                    this.blockGroup.push(block);
                }
            }
        }
    }

    addRescrambleButton(): void {
        var config = new PhaserButtonConfig();
        config.backgroundColor = Color.KUDER_PRIMARY_BUTTON;
        config.smartHeight = true;
        var text = TranslateApi.translate(this.translateString + "reshuffle");
        var button = new PhaserButton(this, this.GAME_WIDTH - 200, 50, 150, 50, text, config);
        button.setDepth(3);
        button.on('buttonClicked', () => {
            if (!this.clickLock) {
                this.startTime = false;
                this.timeText.setText("0:00");
                this.setupTimer();
                this.text.setText("");
                this.outline.setAlpha(0);
                this.speechBox.setAlpha(0);
                this.destroyOldPieces();
                this.setupBoard();
                this.blocksLeftText.destroy();
                this.checkNumLeft();
            }
        });
    }

    addControlPanel(): void {
        let pic: Phaser.GameObjects.Image = this.add.image(780, 55, "template");
        pic.setDepth(3);
        pic.setOrigin(0);
        pic.setAlpha(1);
        pic.setDisplaySize(320, 320);
        let border: Phaser.GameObjects.Image = this.add.image(775, 50, "pixel");
        border.setTint(0x000000);
        border.setOrigin(0);
        border.setDisplaySize(330, 330);
        border.setDepth(2);
        let astronaut: Phaser.GameObjects.Image = this.add.image(1200, 603, "pilots", "i");
        astronaut.setDepth(9);
        astronaut.setOrigin(.5);
        astronaut.setScale(.5, .5);
    }

    switchBlocks(toSwitch: Phaser.GameObjects.Image, black: Phaser.GameObjects.Image): void {
        if (this.clickLock) {
            return;
        }
        let diffX: number = Math.abs(black.x - toSwitch.x);
        let diffY: number = Math.abs(black.y - toSwitch.y);
        if (!this.isBlockMovable(diffX, diffY)) {
            return;
        }
        this.clickLock = true;
        if (!this.startTime) {
            this.setupTimer();
            this.startTime = true;
        }
        // Change the block's locations in the blockgroup array
        let swIndex: number = this.blockGroup.indexOf(toSwitch);
        let blIndex: number = this.blockGroup.indexOf(black);
        this.blockGroup[blIndex] = toSwitch;
        this.blockGroup[swIndex] = black;
        this.moveBlock(toSwitch, this.blackBlock);
    }

    /**
     * moveBlock function adds tween animation to moving blocks
     * @param block
     * @param blackBlock
     */
    moveBlock(block: Phaser.GameObjects.Image, blackBlock: Phaser.GameObjects.Image): void {
        this.tweens.add({
            targets: blackBlock,
            x: block.x,
            y: block.y,
            duration: 400,
            onComplete: () => {
            }
        });
        this.tweens.add({
            targets: block,
            x: blackBlock.x,
            y: blackBlock.y,
            duration: 400,
            onComplete: () => {
                this.clickLock = false;
                this.checkIfCompleted();
            }
        });
    }

    isBlockMovable(diffX: number, diffY: number): boolean {
        if (diffX === (this.PIECE_WIDTH + 2) && diffY === (this.PIECE_HEIGHT + 2)) {
            return false;
        }
        if (diffX > (this.PIECE_WIDTH + 2) || diffY > (this.PIECE_HEIGHT + 2)) {
            return false;
        }

        return true;
    }

    createSolvableIndexArray(): number[] {
        let indexArray = [];
        for (let i = 0; i < this.BOARD_DIM * this.BOARD_DIM; i++) {
            indexArray.push(i);
        }
        let scrambleIndex: number = 0;
        while (scrambleIndex < 6) {
            for (let j = 0; j < 100; j++) {
                let blackIndex = indexArray.indexOf(8);
                let rand = Math.random() * 4;
                if (rand < 1) {
                    if (blackIndex !== 0 && blackIndex !== 3 && blackIndex !== 6) {
                        this.swap(indexArray, blackIndex, blackIndex - 1);
                    }
                }
                else if (rand < 2) {
                    if (blackIndex !== 0 && blackIndex !== 1 && blackIndex !== 2) {
                        this.swap(indexArray, blackIndex, blackIndex - 3);
                    }
                }
                else if (rand < 3) {
                    if (blackIndex !== 2 && blackIndex !== 5 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 1);
                    }
                }
                else if (rand < 4) {
                    if (blackIndex !== 6 && blackIndex !== 7 && blackIndex !== 8) {
                        this.swap(indexArray, blackIndex, blackIndex + 3);
                    }
                }
            }
            for (let i = 0; i < indexArray.length; i++) {
                if (indexArray[i] !== i) {
                    scrambleIndex++;
                }
            }
        }
        return indexArray;
    }
    swap(arr: number[], blackIndex: number, toSwap: number): void {
        let temp: number = arr[toSwap];
        arr[toSwap] = arr[blackIndex];
        arr[blackIndex] = temp;
    }

    makeBlocksLeftBox(): void {
        this.blocksLeftText.setDepth(3);
        let box = this.add.image(this.blocksLeftText.x, this.blocksLeftText.y, "pixel");
        box.setDisplaySize(this.blocksLeftText.displayWidth + 10, this.blocksLeftText.displayHeight + 10);
        box.setDepth(2);
        let edge = this.add.image(box.x, box.y, "pixel");
        edge.setDisplaySize(box.displayWidth + 10, box.displayHeight + 10);
        edge.setTint(0x000000);
        edge.setDepth(1.5);
    }

    checkIfCompleted(): void {
        var count = 0;
        let iter = this.blockGroup.values();
        for (let row = 0; row < this.BOARD_DIM; row++) {
            for (let col = 0; col < this.BOARD_DIM; col++) {
                if (iter.next().value.getData("key") !== count) {
                    this.outline.destroy();
                    this.speechBox.destroy();
                    this.blocksLeftText.destroy();
                    this.text.destroy();
                    let num = this.checkNumLeft();
                    if (this.count > num) {
                        let rand = Math.random() * 4;
                        if (rand < 1) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.1"));
                        }
                        else if (rand < 2) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.2"));
                        }
                        else if (rand < 3) {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.3"));
                        }
                        else {
                            this.outline.setAlpha(1);
                            this.speechBox.setAlpha(1);
                            this.text.setText(TranslateApi.translate(this.translateString + "feedback.4"));
                        }
                    }
                    this.count = num;
                    return;
                }
                count++;
            }
        }
        this.showFinishedText();
        this.blocksLeftText.destroy();
    }

    checkNumLeft(): number {
        let num: number = 0;
        let iter = this.blockGroup.values();
        for (let i = 0; i < this.blockGroup.length; i++) {
            let next = iter.next().value.getData("key");
            if (next !== i) {
                if ((this.BOARD_DIM === 3 && next === 8)) {
                    // dont add to num, black block
                }
                else {
                    num++;
                }
            }
        }

        let scoreText = TranslateApi.translate(this.translateString + "score");
        let str: string = scoreText + num;
        this.blocksLeftText = this.add.text(945, 410, str, { fontFamily: 'Russo One, Roboto Mono, Arial', fill: "#000000", align: "center" }).setFontSize(20);
        this.blocksLeftText.setDepth(3);
        this.blocksLeftText.setOrigin(.5);

        this.text = this.add.text(945, 525, "", { fontFamily: 'Roboto Mono, Russo One, Arial', fill: "#ffffff", align: "center" }).setFontSize(25);
        this.text.setOrigin(.5);
        this.text.setDepth(3);
        this.outline = this.add.image(845, 470, "pixel");
        this.outline.setOrigin(0);
        this.outline.setTint(0x0000ff);
        this.outline.setDisplaySize(200, 110);
        this.outline.setDepth(2.5);
        this.outline.setAlpha(0);
        this.speechBox = this.add.image(850, 475, "pixel");
        this.speechBox.setOrigin(0);
        this.speechBox.setTint(0x000000);
        this.speechBox.setDepth(2.75);
        this.speechBox.setDisplaySize(190, 100);
        this.speechBox.setAlpha(0);

        return num;
    }

    showFinishedText() {
        var style = { fontFamily: 'Russo One, Roboto Mono, Arial', fill: "#0C0C0C", align: "center", font: "40px Arial" };

        this.add.image(0, 0, "bg_done").setDepth(10).setOrigin(0).setDisplaySize(this.GAME_WIDTH, this.GAME_HEIGHT);

        var moveOn = TranslateApi.translate("common.done");
        var buttonConfig = { backgroundColor: 0x6ec213, textColor: 0xffffff, textSize: 30 };
        var buttonText = this.add.text(0, 0, moveOn, style).setVisible(false).setWordWrapWidth(500);
        var button = new PhaserButton(this, 100, 50, buttonText.displayWidth + 10, buttonText.displayHeight + 10, moveOn, buttonConfig);
        button.setDepth(10);
        button.on("buttonClicked", () => {
            this.input.setDefaultCursor("default");
            this.input.removeAllListeners();
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        });
    }

    setupTimer(): void {
        this.timer = this.time.addEvent({ delay: 10000000, timeScale: 1.0 });
        var clock = this.add.image(this.GAME_WIDTH - 125, 200, "pixel").setDisplaySize(110, 50).setDepth(6.5);
        var clockBorder = this.add.image(clock.x, clock.y, "pixel").setDisplaySize(120, 60).setDepth(6).setTint(0x000000);
    }

    setTime(): void {
        if (this.startTime) {
            var minute: number = Math.floor(this.timer.getElapsedSeconds() / 60);
            var second: number = Math.floor(this.timer.getElapsedSeconds() % 60);

            if (second < 10) {
                this.timeText.setText(minute.toString() + ":0" + second.toString());
            }
            else {
                this.timeText.setText(minute.toString() + ":" + second.toString());
            }
        }
    }

    destroyOldPieces(): void {
        let iter = this.blockGroup.values();
        for (let i = 0; i < this.blockGroup.length; i++) {
            iter.next().value.destroy();
        }
    }

    update() {
        this.setTime();
    }
}



// WEBPACK FOOTER //
// ./src/games/XraySlider/scenes/MainScene.ts